<template>
    <div>
        <h2>Add T&E Code</h2>
        <time-expense-form :is-unbound="true" :is-outlook="true" :is-marketing="false"></time-expense-form>
    </div>
</template>

<script>
    import Vue from "vue";
    import MainForm from "./entry-form/main-form.vue";

    Vue.component("time-expense-form", MainForm);

    export default {
        props: {
            action: String
        },
        created() {
            this.$store.state.editId = 0;
            if (this.action === 'continue') {
                this.$store.state.reviveSession = true;
            }
        },
    };
</script>